var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgViewAndShare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "#6A37BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2002 61.2002L75.6002 88.8002",
    stroke: "#EFE4FF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6002 31.2002L31.2002 61.2002",
    stroke: "#EFE4FF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6001 43.2002C82.2275 43.2002 87.6001 37.8276 87.6001 31.2002C87.6001 24.5728 82.2275 19.2002 75.6001 19.2002C68.9727 19.2002 63.6001 24.5728 63.6001 31.2002C63.6001 37.8276 68.9727 43.2002 75.6001 43.2002Z",
    fill: "#32DBDB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6001 100.8C82.2275 100.8 87.6001 95.4272 87.6001 88.7998C87.6001 82.1724 82.2275 76.7998 75.6001 76.7998C68.9727 76.7998 63.6001 82.1724 63.6001 88.7998C63.6001 95.4272 68.9727 100.8 75.6001 100.8Z",
    fill: "#F25112"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2002 73.2002C37.8276 73.2002 43.2002 67.8276 43.2002 61.2002C43.2002 54.5728 37.8276 49.2002 31.2002 49.2002C24.5728 49.2002 19.2002 54.5728 19.2002 61.2002C19.2002 67.8276 24.5728 73.2002 31.2002 73.2002Z",
    fill: "#35B94E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgViewAndShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ViewAndShare.a3da96c78074b414ed87b4d26d1ccf5b.svg";